import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private _alert$ = new BehaviorSubject<string>('');

  get alert$() {
    return this._alert$.asObservable();
  }

  setAlert(mensaje: string) {
    this._alert$.next(mensaje);
  }
}
